import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  mutations: {
    resetState: (state) => state
  },

  actions: {
    async emailExists({ commit }, { email }) {
      try {
        await fetch({
          url: `/api/account-tenancy/${encodeURIComponent(email)}`,
          type: 'account-tenancy'
        })

        return true
      } catch (e) {
        return false
      }
    }
  }
}
